// extracted by mini-css-extract-plugin
export default {"root":"QzbzjSWL","mobile":"HPtWTV_x","spin":"XJKsy2gk"};